import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <RecoilRoot>
        <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
            <App />
        </BrowserRouter>
    </RecoilRoot>
);
